import { SurveyError } from 'survey-core' // 10MB

/**
 * 画像アップロードで許可する拡張子
 * docs: https://developers.cloudflare.com/images/upload-images/#supported-image-formats
 */
export const acceptedTypesForImages = [
  'image/png',
  'image/jpeg',
  'image/webp',
]

export const maxImageSize = 10_485_760

export type ValidationType = 'none' | 'alphanumericWithSymbols' | 'alphanumericOnly'

/**
 * バリデーションエラーメッセージ
 */
export const ValidationErrorMessages = {
  REQUIRED: '質問にお答え下さい',
  ALPHANUMERIC_WITH_SYMBOLS: '半角英数記号のみである必要があります',
  ALPHANUMERIC_ONLY: '半角英数のみである必要があります',
  INVALID_NUMBER: '数値を入力してください',
  MIN_NUMBER: (min: number) => `${min}以上の値を入力してください`,
  MAX_NUMBER: (max: number) => `${max}以下の値を入力してください`,
  STEP_NUMBER: (step: number) => `${step}刻みの値を入力してください`,
  MIN_DATE: (min: string) => `${min}以降の日付を入力してください`,
  MAX_DATE: (max: string) => `${max}以前の日付を入力してください`,
  INVALID_DATE: '有効な日付を入力してください',
  GENERAL_ERROR: '回答をご確認ください',
  UPLOADING: 'ファイルをアップロード中です。しばらくしてから再度お試しください。',
} as const

/**
 * テキスト入力のバリデーションを行う
 * @param value 質問の値
 * @param questionType 質問のタイプ（例: 'text' | 'comment'）
 * @param validationType バリデーションの種類
 * @returns SurveyError[] エラーがあればエラーオブジェクトの配列、なければ空配列
 */
export function validateTextInput(value: string, questionType: string, validationType: ValidationType): SurveyError[] {
  const errors: SurveyError[] = []

  if (questionType !== 'text' && questionType !== 'comment') {
    return errors
  }

  if (!value || validationType === 'none') {
    return errors
  }

  switch (validationType) {
    case 'alphanumericWithSymbols': {
      const alphanumericRegex = /^[\w!@#$%^&*()+\-=[\]{};':"\\|,.<>/?]*$/
      if (!alphanumericRegex.test(value)) {
        errors.push(new SurveyError(ValidationErrorMessages.ALPHANUMERIC_WITH_SYMBOLS))
      }
      break
    }
    case 'alphanumericOnly': {
      const alphanumericOnlyRegex = /^[a-z0-9]*$/i
      if (!alphanumericOnlyRegex.test(value)) {
        errors.push(new SurveyError(ValidationErrorMessages.ALPHANUMERIC_ONLY))
      }
      break
    }
  }

  return errors
}
